import { useCallback } from 'react';

/**
 * Processes lease data and returns structured values for Formik.
 *
 * @param {Object} params - Parameters required to process the lease data.
 * @param {Object} params.lease - Lease data from the API.
 * @returns {Object} - Structured lease data to be used as Formik values.
 */
const populateFormWithLeaseData = ({ lease }) => {
  // Initialize the result object
  const structuredData = {};

  // Fields to update, same as before
  const fieldsToUpdate = [
    'property_details',
    'manager',
    'tenants',
    'lease_details',
    'security_deposits',
    'occupants',
    'attached_documents',
    'additional_notes',
    'version_info',
    'lease_status',
    'createdAt'
  ];

  // Merge lease data into structuredData for each field
  fieldsToUpdate.forEach((field) => {
    if (lease[field]) {
      structuredData[field] = lease[field];
    }
  });

  // Explicitly handle arrays to preserve structure
  if (lease.occupants) {
    structuredData.occupants = lease.occupants;
  }

  if (lease.attached_documents) {
    structuredData.attached_documents = lease.attached_documents;
  }

  // Return the lease ID separately for convenience
  return {
    leaseData: structuredData,
    leaseId: lease._id || null,
  };
};

export { populateFormWithLeaseData };